import { useState } from "react";
import { ArrowUpRight, ArrowLeft } from "lucide-react";
import { api, errorText } from "@/lib/api";

const Art = () => (
  <div className="auth-art">
    <div className="brand brand-light"><span className="brand-logo-pill"><img src="/demkan-logo.png" alt="Demkan Finans" className="brand-logo" data-testid="auth-art-logo" /></span><span className="brand-sub">Finans</span></div>
    <div className="auth-art-copy"><span className="eyebrow">Finansın yeni kontrol merkezi</span><h1>Rakamlar net,<br /><em>kararlar güçlü.</em></h1><p>Gelirden nakit akışına, işletmenizin tüm finansal fotoğrafı tek ekranda.</p></div>
  </div>
);

const Field = ({ label, testId, ...props }) => <label>{label}<input data-testid={testId} required {...props} /></label>;

const LoginForm = ({ onLogin, toForgot }) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { const r = await api.post("/auth/login", form); onLogin(r.data); } catch (err) { setError(errorText(err, "Bilgileri kontrol edip tekrar deneyin.")); }
  };
  return <>
    <div className="form-heading"><span className="eyebrow">Hoş geldiniz</span><h2>Finansınızı yönetin.</h2><p>Yetkili kullanıcı adınız ve şifrenizle giriş yapın.</p></div>
    <form onSubmit={submit} data-testid="auth-form">
      <Field label="Kullanıcı adı" testId="auth-email-input" type="text" autoComplete="username" placeholder="demkanmakina" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
      <Field label="Şifre" testId="auth-password-input" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
      {error && <div className="form-error" data-testid="auth-error">{error}</div>}
      <button className="primary-btn" data-testid="auth-submit-button">Giriş yap <ArrowUpRight size={17} /></button>
    </form>
    <button className="switch-btn" onClick={toForgot} data-testid="forgot-password-link">Şifremi unuttum</button>
  </>;
};

const ForgotForm = ({ back }) => {
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { const r = await api.post("/auth/forgot-password", {}); setMsg(r.data.message); } catch (err) { setError(errorText(err)); } finally { setBusy(false); }
  };
  return <>
    <div className="form-heading"><span className="eyebrow">Şifremi unuttum</span><h2>Şifrenizi sıfırlayın.</h2><p>Butona bastığınızda yetkili hesabın kayıtlı e-posta adresine tek kullanımlık bir sıfırlama bağlantısı gönderilir.</p></div>
    {msg ? <div className="form-success" data-testid="forgot-success">{msg}</div> : <form onSubmit={submit} data-testid="forgot-form">
      {error && <div className="form-error" data-testid="forgot-error">{error}</div>}
      <button className="primary-btn" disabled={busy} data-testid="forgot-submit-button">{busy ? "Gönderiliyor..." : "Sıfırlama bağlantısı gönder"} <ArrowUpRight size={17} /></button>
    </form>}
    <button className="switch-btn" onClick={back} data-testid="back-to-login"><ArrowLeft size={14} /> Girişe dön</button>
  </>;
};

const ResetForm = ({ token, back }) => {
  const [pw, setPw] = useState({ a: "", b: "" });
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) { setError("Şifreler eşleşmiyor"); return; }
    try { await api.post("/auth/reset-password", { token, password: pw.a }); setDone(true); window.history.replaceState({}, "", "/"); } catch (err) { setError(errorText(err)); }
  };
  return <>
    <div className="form-heading"><span className="eyebrow">Yeni şifre</span><h2>Yeni şifrenizi belirleyin.</h2><p>En az 8 karakter kullanın.</p></div>
    {done ? <div className="form-success" data-testid="reset-success">Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.</div> : <form onSubmit={submit} data-testid="reset-form">
      <Field label="Yeni şifre" testId="reset-password-input" type="password" minLength={8} value={pw.a} onChange={e => setPw({ ...pw, a: e.target.value })} />
      <Field label="Yeni şifre (tekrar)" testId="reset-password-confirm-input" type="password" minLength={8} value={pw.b} onChange={e => setPw({ ...pw, b: e.target.value })} />
      {error && <div className="form-error" data-testid="reset-error">{error}</div>}
      <button className="primary-btn" data-testid="reset-submit-button">Şifreyi güncelle <ArrowUpRight size={17} /></button>
    </form>}
    <button className="switch-btn" onClick={back} data-testid="reset-back-to-login"><ArrowLeft size={14} /> Girişe dön</button>
  </>;
};

export default function AuthPage({ onLogin }) {
  const token = new URLSearchParams(window.location.search).get("reset");
  const [mode, setMode] = useState(token ? "reset" : "login");
  const toLogin = () => { window.history.replaceState({}, "", "/"); setMode("login"); };
  return (
    <main className="auth-shell"><Art />
      <section className="auth-form">
        <div className="brand"><img src="/demkan-logo.png" alt="Demkan Finans" className="brand-logo" data-testid="auth-logo" /><span className="brand-sub">Finans</span></div>
        {mode === "login" && <LoginForm onLogin={onLogin} toForgot={() => setMode("forgot")} />}
        {mode === "forgot" && <ForgotForm back={toLogin} />}
        {mode === "reset" && <ResetForm token={token} back={toLogin} />}
      </section>
    </main>
  );
}
